import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';
import { cn } from './cn.js';
const alertVariants = cva('flex items-start gap-3 rounded-lg border px-4 py-3 text-body', {
    variants: {
        tone: {
            neutral: 'border-border bg-card text-foreground',
            info: 'border-info/30 bg-info-soft text-foreground',
            success: 'border-success/30 bg-success-soft text-foreground',
            warning: 'border-warning-text/30 bg-warning-soft text-foreground',
            error: 'border-destructive/30 bg-destructive-soft text-foreground',
        },
    },
    defaultVariants: { tone: 'info' },
});
const toneIcon = {
    neutral: Info,
    info: Info,
    success: CheckCircle2,
    warning: AlertTriangle,
    error: XCircle,
};
const toneTextClass = {
    neutral: 'text-foreground',
    info: 'text-info-soft-foreground',
    success: 'text-success-soft-foreground',
    warning: 'text-warning-soft-foreground',
    error: 'text-destructive-soft-foreground',
};
/**
 * An inline notice that stays until the condition clears, placed directly
 * above what it concerns. An error tone announces itself (`role="alert"`) so a
 * failed encode or a failed save is read out without the operator having to
 * hunt for it; every other tone is a polite status region.
 */
export function Alert({ className, tone: toneProp = 'info', title, description, action, showIcon = true, children, ...props }) {
    const tone = toneProp === 'destructive' ? 'error' : toneProp;
    const Icon = toneIcon[tone];
    return (_jsxs("div", { role: tone === 'error' ? 'alert' : 'status', "aria-live": tone === 'error' ? 'assertive' : 'polite', "data-slot": "alert", className: cn(alertVariants({ tone }), className), ...props, children: [showIcon && _jsx(Icon, { className: cn('mt-0.5 size-4 shrink-0', toneTextClass[tone]), "aria-hidden": "true" }), _jsxs("div", { className: "flex min-w-0 flex-1 flex-col gap-0.5", children: [_jsx("p", { className: cn('font-semibold', toneTextClass[tone]), children: title }), description != null && _jsx("div", { className: "text-muted-foreground", children: description }), children] }), action != null && _jsx("div", { className: "shrink-0 self-center", children: action })] }));
}
export { alertVariants };
//# sourceMappingURL=alert.js.map